import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10cd1989"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-100 w-100 text-right" }
const _hoisted_2 = { class: "d-flex justify-space-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "h-50 text-body-2 mt-1" }, "EvolveLAB Veras | 1.5.1.2", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  class: "flex m-auto h-100 w-100 pb-8",
  src: "https://veras.evolvelab.io",
  frameBorder: "0"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-2 font-weight-bold mb-3" }, " Veras Integration for Vue.js + TypeScript App ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "demo",
  class: "text-cente"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showVerasPane)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "draggableContainer",
          class: "veras-modal",
          onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragMouseDown && _ctx.dragMouseDown(...args)))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_v_btn, {
                density: "compact",
                icon: "mdi-close",
                variant: "plain",
                class: "mb-1",
                onClick: _ctx.startVeras
              }, null, 8, ["onClick"])
            ]),
            _withDirectives(_createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDragging = !_ctx.isDragging)),
              class: "veras-dragmask h-100 w-100"
            }, null, 512), [
              [_vShow, _ctx.isDragging]
            ]),
            _hoisted_4
          ])
        ], 544))
      : _createCommentVNode("", true),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "text-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: require('../assets/logo.png'),
                  class: "my-3",
                  contain: "",
                  height: "200"
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi-open-in-new",
                  class: "mx-1",
                  onClick: _ctx.startVeras
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Start Veras ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi-eraser",
                  ref: "clearCanvas",
                  class: "mx-1",
                  onClick: _ctx.clearCanvas
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Clear Canvas ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { justify: "center" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}